import { createFileRoute } from '@tanstack/react-router';

import { AccountSecurityPage } from '@/areas/settings/OrganizationSettings/pages/AccountSecurityPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/user/account-security')({
    staticData: { access: { permissions: ['view:organization_settings'] }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AccountSecurityPage />;
}
